
/**
 * @file Drupalに登録されている国コードを取得する
 */

import axios from 'axios'
import PathUtil from '../../modules/util/PathUtil'
import JsonUtil from '../util/JsonUtil'

// ---------------------------------------------------------------
// 定数
const COUNTRY_JSON_PATH = PathUtil.makePath('/json/taxonomy/country.json')

// ---------------------------------------------------------------
// 関数

export class Country {
  public code = ''
  public name = ''

  /**
   * オブジェクトの作成
   *
   * @param data JSONレコード
   * @returns JSONから作成したオブジェクト
   */
  public static crate(data: Record<string, unknown>): Country {
    const obj: Country = JsonUtil.jsonToObject<Country>(Country, data)
    return obj
  }
}

export class CountryList {

  /**
   * 国リストを取得する
   *
   * @returns 国リスト
   */
  public static async getCountryList(): Promise<Country[]> {
    let list: Country[] = []
    try {
      const res = await axios.get(COUNTRY_JSON_PATH);
      const data = res.data
      list = await data.map(Country.crate)

    } catch (error) {
      throw new Error('Failed to retrieve country list.')
    }

    return list
  }
}
